module.exports = __webpack_public_path__ + "img/logo.b2bce899.png";